import * as React from "react";

import { useRecordContext } from "react-admin";
import { Chip } from "@mui/material";

import { useTranslate } from "react-admin";

const RoleChipField = ({ source }: { source: string }) => {
  const record = useRecordContext();

  const translate = useTranslate();

  if (!record || !source) {
    return null;
  }

  const role = record[source];

  const value = role ? translate(`resources.Account.roles.${role}`) : "-";

  return <Chip label={value} sx={{ margin: "4px" }} />;
};

export default RoleChipField;
